export default __webpack_public_path__ + "static/media/plus.b6764be1.svg";